import React from "react";
import { ThemeProvider } from "styled-components";
import { theme, themeChakraUi } from "./styles/theme";
import { GlobalStyle } from "./styles/globalStyles";
import { Outlet } from "react-router-dom";
import LoginContextProvider from "./context/loginContext";
import UsuallyContextProvider from "@context/usuallyContex";
import { ChakraProvider } from "@chakra-ui/react";
import OportunityContexProvider from "@context/oportunityContex";
import MenuSideBar from "@components/common/MenuSideBar";
import ErrorBoundary from "@components/common/ErrorBoundary";
import maintenanceServiceInstance from "@services/Maintenance/MaintanceService";
import Spinner from "@components/common/Spinner";
import Maintenance from "./pages/Maintenance";
import ChatBot from "@components/common/ChatBot";
import AppDownloadModal from "@components/common/AppDownloadModal";
import { useAppDownloadModal } from "@hook/useAppDownloadModal";

export const ThemeContext: any = React.createContext(null);

// Componente interno para usar os hooks após os providers
const AppContent: React.FC = () => {
  const { showModal, closeModal } = useAppDownloadModal();

  // Memoize o layout principal para evitar re-renderizações
  const appLayout = React.useMemo(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100vw",
          }}
        >
          <GlobalStyle />
          <MenuSideBar />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
            }}
          >
            <Outlet />
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          <ChatBot />
        </div>

        {/* Modal de download do app - apenas para mobile web */}
        <AppDownloadModal isOpen={showModal} onClose={closeModal} />
      </>
    ),
    [showModal, closeModal],
  );

  return appLayout;
};

function App() {
  const [themes, setThemes] = React.useState("");
  const themeGlobal = React.useMemo(() => ({ themes, setThemes }), [themes]);
  //Exibir Tela de Manutenção
  const [isMaintenanceMode, setIsMaintenanceMode] = React.useState(false);
  const [isCheckingMaintenance, setIsCheckingMaintenance] =
    React.useState(true);

  // Verificar o status de manutenção quando o componente montar
  React.useEffect(() => {
    const checkMaintenanceStatus = async () => {
      try {
        const response =
          await maintenanceServiceInstance.getStatusMaintenance();

        setIsMaintenanceMode(response);
      } catch (error) {
        console.error("Erro ao verificar status de manutenção:", error);
        setIsMaintenanceMode(false);
      } finally {
        setIsCheckingMaintenance(false);
      }
    };

    checkMaintenanceStatus();
  }, []);

  // Mostrar um indicador de carregamento enquanto verifica o status de manutenção
  if (isCheckingMaintenance) {
    return (
      <ChakraProvider theme={themeChakraUi}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spinner />
        </div>
      </ChakraProvider>
    );
  }

  // Mostrar a tela de manutenção se o site estiver em manutenção
  if (isMaintenanceMode) {
    return (
      <ChakraProvider theme={themeChakraUi}>
        <Maintenance />
      </ChakraProvider>
    );
  }

  return (
    <ErrorBoundary>
      <LoginContextProvider>
        <UsuallyContextProvider>
          <OportunityContexProvider>
            <ThemeContext.Provider value={themeGlobal}>
              <ThemeProvider theme={theme}>
                <ChakraProvider theme={themeChakraUi}>
                  <AppContent />
                </ChakraProvider>
              </ThemeProvider>
            </ThemeContext.Provider>
          </OportunityContexProvider>
        </UsuallyContextProvider>
      </LoginContextProvider>
    </ErrorBoundary>
  );
}

export default App;
